import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import './LoginModal.css';

const LoginModal = ({ onClose, onLogin }) => {
  const [isLogin, setIsLogin] = useState(true); // true为登录，false为注册
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [username, setUsername] = useState(''); // 添加用户名
  const [ieltsDeadline, setIeltsDeadline] = useState(''); // 添加雅思倒计时
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const language = localStorage.getItem('language') || 'en';

  // 表单提交处理
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        // 登录逻辑
        const response = await fetch(API_ENDPOINTS.login, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, password }),
        }).catch(err => {
          console.error('Network error during login:', err);
          throw new Error(language === 'en' 
            ? 'Network error. Please check your internet connection.' 
            : '网络错误，请检查您的网络连接。');
        });

        if (!response) {
          throw new Error(language === 'en' 
            ? 'Cannot connect to server. Please try again later.' 
            : '无法连接到服务器，请稍后再试。');
        }

        const data = await response.json().catch(err => {
          console.error('Error parsing response:', err);
          throw new Error(language === 'en' 
            ? 'Invalid server response. Please try again.' 
            : '服务器响应无效，请重试。');
        });
        
        if (!response.ok) {
          throw new Error(data.message || (language === 'en' 
            ? 'Login failed. Please check your credentials.' 
            : '登录失败，请检查您的凭据。'));
        }

        // 保存用户信息和token
        localStorage.setItem('talktastic_user', JSON.stringify(data.user));
        localStorage.setItem('talktastic_token', data.token);
        
        if (onLogin) {
          onLogin(data.user);
        }
      } else {
        // 注册逻辑
        if (password !== confirmPassword) {
          throw new Error(language === 'en' 
            ? 'Passwords do not match' 
            : '两次输入的密码不匹配');
        }
        
        const response = await fetch(API_ENDPOINTS.register, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            email, 
            password, 
            username,
            ieltsDeadline: ieltsDeadline ? parseInt(ieltsDeadline) : null 
          }),
        }).catch(err => {
          console.error('Network error during registration:', err);
          throw new Error(language === 'en' 
            ? 'Network error. Please check your internet connection.' 
            : '网络错误，请检查您的网络连接。');
        });

        if (!response) {
          throw new Error(language === 'en' 
            ? 'Cannot connect to server. Please try again later.' 
            : '无法连接到服务器，请稍后再试。');
        }

        const data = await response.json().catch(err => {
          console.error('Error parsing response:', err);
          throw new Error(language === 'en' 
            ? 'Invalid server response. Please try again.' 
            : '服务器响应无效，请重试。');
        });
        
        if (!response.ok) {
          throw new Error(data.message || (language === 'en' 
            ? 'Registration failed. Please try again.' 
            : '注册失败，请重试。'));
        }

        // 保存用户信息和token
        localStorage.setItem('talktastic_user', JSON.stringify(data.user));
        localStorage.setItem('talktastic_token', data.token);
        
        if (onLogin) {
          onLogin(data.user);
        }
      }
    } catch (error) {
      console.error('Auth error:', error);
      setError(error.message || (language === 'en' 
        ? 'An unknown error occurred' 
        : '发生未知错误'));
    } finally {
      setLoading(false);
    }
  };

  // 切换登录/注册表单
  const toggleForm = () => {
    setIsLogin(!isLogin);
    setError('');
  };

  return (
    <div className="login-modal-overlay">
      <div className="login-modal">
        <button onClick={onClose} className="close-btn">&times;</button>
        
        <div className="login-header">
          <h2>{isLogin 
            ? (language === 'en' ? 'Login' : '登录') 
            : (language === 'en' ? 'Register' : '注册')}
          </h2>
          <p>
            {isLogin 
              ? (language === 'en' 
                  ? 'Login to view your personalized score report' 
                  : '登录以查看您的个性化提分报告') 
              : (language === 'en' 
                  ? 'Create an account to save your progress' 
                  : '创建账号以保存您的学习进度')}
          </p>
        </div>

        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{language === 'en' ? 'Email' : '邮箱'}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={language === 'en' ? 'Enter your email' : '输入您的邮箱'}
              required
            />
          </div>
          
          <div className="form-group">
            <label>{language === 'en' ? 'Password' : '密码'}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={language === 'en' ? 'Enter your password' : '输入您的密码'}
              required
            />
          </div>
          
          {!isLogin && (
            <>
              <div className="form-group">
                <label>{language === 'en' ? 'Confirm Password' : '确认密码'}</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={language === 'en' ? 'Confirm your password' : '再次输入密码'}
                  required
                />
              </div>
              
              <div className="form-group">
                <label>{language === 'en' ? 'Username' : '用户名'}</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder={language === 'en' ? 'Enter your username' : '输入您的用户名'}
                  required
                />
              </div>
              
              <div className="form-group">
                <label>{language === 'en' ? 'IELTS Exam Deadline (days)' : '雅思考试倒计时 (天数)'}</label>
                <input
                  type="number"
                  value={ieltsDeadline}
                  onChange={(e) => setIeltsDeadline(e.target.value)}
                  placeholder={language === 'en' ? 'Enter days until your exam' : '输入距离考试的天数'}
                />
              </div>
            </>
          )}
          
          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading 
              ? (language === 'en' ? 'Processing...' : '处理中...') 
              : (isLogin 
                  ? (language === 'en' ? 'Login' : '登录') 
                  : (language === 'en' ? 'Register' : '注册'))}
          </button>
        </form>
        
        <div className="form-switch">
          {isLogin 
            ? (language === 'en' 
                ? "Don't have an account? " 
                : '还没有账号？') 
            : (language === 'en' 
                ? 'Already have an account? ' 
                : '已有账号？')}
          <button 
            onClick={toggleForm}
            className="switch-btn"
          >
            {isLogin 
              ? (language === 'en' ? 'Register now' : '立即注册') 
              : (language === 'en' ? 'Login' : '登录')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal; 